define('plugin/classes/model/ClassesPluginModel',['require','backbone','collection/TimeSlotCollection'],function (require) {

    var Backbone = require('backbone');
    var TimeSlotCollection = require('collection/TimeSlotCollection');

    /**
     * Classes time info model
     *
     * @class ClassesPluginModel
     */
    return Backbone.Model.extend({

        defaults: {
            id: '',
            date: '',
            provider_id: '',
            service_id: '',
            slots: null
        },

        parse: function () {
            var data = Backbone.Model.prototype.parse.apply(this, arguments);

            return _.extend(data, {
                slots: new TimeSlotCollection(data.slots)
            });
        }

    });

});
